export const endpoints = {
  auth: {
    signup: "auth/signup",
    login: "auth/login",
    providerSignup: "auth/signup/provider",
    refreshToken: "auth/refresh-token",
  },

  user: {
    getUser: "user/me",
  },
};
